import {atomWithReset} from 'jotai/utils'

// 'https://staging-api.mycryptoprofile.io'
export const MCP_ENDPOINT_PREFIX = process.env.NEXT_PUBLIC_MCP_ENDPOINT_PREFIX ||
  'https://api.mycryptoprofile.io'

export const mcpEndpointPrefixAtom = atomWithReset(MCP_ENDPOINT_PREFIX)

export const PWAPI_ENDPOINT_PREFIX = process.env.NEXT_PUBLIC_PWAPI_ENDPOINT_PREFIX ||
  'https://api.phala.world'

export const pwapiEndpointPrefixAtom = atomWithReset(PWAPI_ENDPOINT_PREFIX)
